import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class SlashHash extends React.Component {

    render() {

        const { classes, iriType, onChange, margin } = this.props;

        return (
            <TitledPanel title="IRI Pattern" margin={margin}>
                <FormControl component="fieldset" style={{marginLeft: 12}}>
                    <legend className={classes.hideLegend}>Slash or hash IRI pattern</legend>
                    <RadioGroup row aria-label="Select slash or hash IRI pattern" name="iriType" value={iriType} onChange={onChange}>
                        <FormControlLabel data-test="select-slash" value="Slash" control={<Radio color="primary" />} label="Slash"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-hash" value="Hash" control={<Radio color="primary" />} label="Hash"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
            </TitledPanel>
        );
    }
}

SlashHash.defaultProps = {
    margin: true
};

SlashHash.propTypes = {
    iriType: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(SlashHash);